// Switch. The whole card is the target, because the honest warning copy beside
// it is what a parent actually reads before turning Veteran on (REFOCUS §3).

import { button, div, h } from '../dom';

export interface ToggleOptions {
  label: string;
  description: string;
  pressed: boolean;
  /** Veteran reads as a danger, not as the ordinary clay accent. */
  tone?: 'clay' | 'danger';
  onChange: (next: boolean) => void;
}

export function toggle(options: ToggleOptions): HTMLElement {
  const card = button({
    class: `cf-toggle${options.pressed ? ' cf-toggle--on' : ''}`,
    attrs: { 'aria-pressed': String(options.pressed) },
    on: { click: () => options.onChange(!options.pressed) },
  });
  card.append(
    div(
      { class: 'cf-stack cf-stack--tight cf-grow' },
      h('span', { class: 'cf-toggle__label', text: options.label }),
      h('span', { class: 'cf-toggle__desc', text: options.description }),
    ),
    h('span', { class: 'cf-switch', attrs: { 'data-tone': options.tone ?? 'clay' } }),
  );
  return card;
}
